module.exports = __webpack_public_path__ + "img/n1.02ce9a1e.png";